import { createContext } from 'react';

const ProfileContext = createContext(null);
export default ProfileContext;
